import { render, staticRenderFns } from "./IE.vue?vue&type=template&id=ff120144&scoped=true"
import script from "./IE.vue?vue&type=script&lang=js"
export * from "./IE.vue?vue&type=script&lang=js"
import style0 from "./IE.vue?vue&type=style&index=0&id=ff120144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff120144",
  null
  
)

export default component.exports